import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-awardsandrecognition',
  templateUrl: './awardsandrecognition.component.html',
  styleUrls: ['./awardsandrecognition.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AwardsandrecognitionComponent implements OnInit {

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  }


  slides = [
    {
      index: 1,
      img: "assets/images/new/cybersecurity_company_of_the_year.webp",
    },
    {
      index: 2,
      img: "assets/images/new/innovation_security.png",
    },
    {
      index: 3,
      img: "assets/images/new/award_4.webp",
    },
    {
      index: 4,
      img: "assets/images/new/award_2.webp",
    },
    {
      index: 5,
      img: "assets/images/new/award_1.webp",
    },
    {
      index: 6,
      img: "assets/images/new/award_3.webp",
    },
    {
      index: 7,
      img: "assets/images/new/award_5.webp",
    },
    {
      index: 8,
      img: "assets/images/new/award_6.webp",
    },
  ];

  // slideConfig = { "slidesToShow": 4, "slidesToScroll": 4, "autoplay": true, "autoplaySpeed": 4000, "dots": true, prevArrow: null, nextArrow: null };
  slideConfig = {
    "slidesToShow": 4,
    "slidesToScroll": 4,
    "autoplay": true,
    "autoplaySpeed": 4000,
    "dots": true,
    prevArrow: null,
    nextArrow: null,
    responsive: [
      {
        breakpoint: 1200, // Adjust this value based on your design requirements
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 992, // Adjust this value based on your design requirements
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 768, // Adjust this value based on your design requirements
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // Add more breakpoints as needed
    ]
  };


  slickInit() {
    // $(".slide.slick-slide .custom-box-content").hide();
    // $(".slide.slick-slide.slick-active .custom-box-content").show();
  }
  testimonialInit() {
    // $(".slide.slick-slide .custom-box-content").hide();
    // $(".slide.slick-slide.slick-active .custom-box-content").show();
  }
  breakpoint() {
  }

  afterChange() {
    this.slickInit()
    this.testimonialInit()
    // $(".slide.slick-slide .custom-box-content").hide();
    // $(".slide.slick-slide.slick-active .custom-box-content").show();
    // //$(".bnrcontent").css("visibility", "visible");
    // $(".bnrcontent").css("transform", "translateZ(0)");
    // $(".bnrcontent").css("transition-duration", "3s");

  }


  beforeChange() {
    // //$(".bnrcontent").css("visibility", "hidden");
    // $(".bnrcontent").css("transform", "translate3d(100px,0,0)");
    // $(".bnrcontent").css("transition-duration", "3s");
  }

}
